import gql from 'graphql-tag'
import { type CustomApolloClient } from 'api/utils/apollo/client/apolloClient.types'

export type RetailerLocation = {
  id: string
  name: string
}

export type StoreGroup = {
  id: string
  name: string
  retailerLocations: RetailerLocation[]
}

type StoreGroupsByRetailerResponse = {
  retailerLocationGroupsByRetailer: {
    nodes: {
      id: string
      name: string
      retailerLocations: {
        nodes: RetailerLocation[]
      }
    }[]
  }
  nodes: {}
}

// We're need to query by X numb of retailers for the admin page so a hook can't be used since there
// would be a variable number of hook calls
const STORE_GROUPS_BY_RETAILER_QUERY = gql`
  query getStoreGroupsByRetailer($retailerId: ID!) {
    retailerLocationGroupsByRetailer(retailerId: $retailerId) {
      nodes {
        id
        name
        retailerLocations {
          nodes {
            id
            name
          }
        }
      }
    }
  }
`

export const queryStoreGroups = (client: CustomApolloClient, retailerId: string) =>
  client
    .query<StoreGroupsByRetailerResponse>({
      query: STORE_GROUPS_BY_RETAILER_QUERY,
      variables: { retailerId },
    })
    .then(response => ({
      ...response,
      data: response?.data?.retailerLocationGroupsByRetailer?.nodes?.map(storeGroup => ({
        id: storeGroup?.id,
        name: storeGroup?.name,
        retailerLocations: storeGroup?.retailerLocations?.nodes?.map(retailerLocation => ({
          id: retailerLocation.id,
          name: retailerLocation.name,
        })),
      })),
    }))
